import { DEFAULT_BRANDING } from '../schemas/morningConfig'

export function fallbackLogoSource(currentSource: string) {
  return currentSource === DEFAULT_BRANDING.logo ? currentSource : DEFAULT_BRANDING.logo
}
